const numberRegex = /\d+/

const setVideoSource = function (video, inlineOnly = false) {
  const sources = video.querySelectorAll('source')
  let sourceSet = false
  let i = 0

  if (sources.length === 1) {
    video.src = sources[0].dataset.src
    return
  }

  while (sourceSet === false) {
    const source = sources.length > i + 1 ? sources[i] : null

    // If source is undefined (basically means if there is no version of the video for large desktops)
    // Revert to the previous source
    if (source === null) {
      if (i > 0) {
        video.src = sources[i - 1].dataset.src
        sourceSet = true
      }
      return
    }

    const mediaQuery = source.dataset.media

    if (mediaQuery === '' || mediaQuery === null) {
      video.src = source.dataset.src
      sourceSet = true
      return
    }

    if (inlineOnly === true) {
      const width = video.offsetWidth > (video.offsetHeight / 0.5625) ? video.offsetWidth : video.offsetHeight * 1.777
      const widthFromQuery = mediaQuery.match(numberRegex)

      const queryWidth = widthFromQuery ? parseInt(widthFromQuery[0]) : null

      if (queryWidth !== null && width <= queryWidth) {
        video.src = source.dataset.src
        sourceSet = true
      }
    } else {
      if (window.matchMedia(mediaQuery).matches) {
        video.src = source.dataset.src
        sourceSet = true
      }
    }

    i++
  }
}

const getVimeoSources = function (vimeoData) {
  const data = JSON.parse(vimeoData)

  const sources = data.map(version => {
    if (version === data[data.length - 1]) {
      return `<source data-src="${version.link}" media="" type="${version.videoType}" />`
    }

    return `<source data-src="${version.link}" media="(max-width: ${version.width}px)" type="${version.videoType}" />`
  })

  return sources.join('')
}

export {
  setVideoSource,
  getVimeoSources
}
